import React from "react";

const AssetCard = ({ name, src }) => {
  const handleCopyLink = () => {
    const fullUrl = `${window.location.origin}${src}`;
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        alert(`Link copied to clipboard: ${fullUrl}`);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="asset-card" onClick={handleCopyLink}>
      <img src={src} alt={name} />
      <div className="asset-name">{name}</div>
    </div>
  );
};

export default AssetCard;
